<template>
    <div>
        <HowTo/>
        <div v-if="showAppDown">
            <div class="panel" align="center">
                <h4 class="redColoredText">
                    Anwendung nicht verfügbar
                </h4>
                <p>
                    Die Anwendung steht aktuell leider nicht zur Verfügung. Bitte versuchen Sie es später erneut.
                </p>
            </div>
        </div>
        <div v-else-if="isInitializationDone" class="panel" ref="entschaedigungsmanager">
            <StartPage
                v-show="showStartPage"
                :case-data="caseData"
                @goToCalculatePage="toogleCalculatePage"
                @scrollToTop="scrollToTop"
            />
            <CalculatePage
                v-if="showCalculatePage"
                :case-data="caseData"
                :mandator="mandator"
                :fellow-passengers="fellowPassengers"
                :expenses="expenses"
                :compensation-result="calculateCompensationResult"
                @goToStartPage="toogleStartPage"
                @goToConfirmationPage="toogleConfirmationPage"
                @scrollToTop="scrollToTop"
                @updateExpenses="updateExpenses"
                @updateFellowPassengers="updateFellowPassengers"
            />
            <ConfirmationPage v-if="showConfirmationPage"/>
        </div>
        <Disclaimer/>
    </div>
</template>

<script>
import StartPage from './StartPage';
import HowTo from '../components/HowTo';
import Disclaimer from '../components/Disclaimer';
import CalculatePage from './CalculatePage';
import ConfirmationPage from './ConfirmationPage';
import Config from '../constants/Config';
import Maintenance from '../api/maintenance';
export default {
    name: 'BasePage',
    components: {ConfirmationPage, CalculatePage, Disclaimer, HowTo, StartPage},
    data: () => ({
        caseData: {
            start: null,
            start_longitude: null,
            start_latitude: null,
            start_country: null,
            end: null,
            end_longitude: null,
            end_latitude: null,
            end_country: null,
            stopover: null,
            type: null,
            planned_relevant_date: null,
            actual_relevant_date: null,
            cause: null,
            was_late_for_boarding: null,
            was_boarding_lateness_acceptable: null,
            flightnumber_main: null,
            flightnumber_sub: null,
            distance: null,
            flightdate: null,
            main_airline_id: null,
            sub_airline_id: null,
            rsv_id: null
        },
        mandator: {
            lawform: null,
            prename: null,
            surname: null,
            street: null,
            house_number: null,
            zip: null,
            city: null,
            mail: null,
            phone: null,
            iban: null,
            bic: null
        },
        fellowPassengers: [],
        expenses: [],
        showStartPage: true,
        showCalculatePage: false,
        showConfirmationPage: false,
        calculateCompensationResult: null,
        showAppDown: false,
        isInitializationDone: false
    }),
    methods: {
        toogleStartPage()
        {
            this.showCalculatePage = false;
            this.showConfirmationPage = false;
            this.showStartPage = true;
            this.scrollToTop();
        },
        toogleCalculatePage(calculateResult)
        {
            this.calculateCompensationResult = calculateResult;
            this.showStartPage = false;
            this.showConfirmationPage = false;
            this.showCalculatePage = true;
            this.scrollToTop();
        },
        toogleConfirmationPage()
        {
            this.showStartPage = false;
            this.showCalculatePage = false;
            this.showConfirmationPage = true;
            this.scrollToTop();
            this.createTrackingIframe();
        },
        scrollToTop()
        {
            this.$refs.entschaedigungsmanager.scrollIntoView(true);
        },
        updateExpenses(newValue)
        {
            this.expenses = newValue;
        },
        updateFellowPassengers(newValue)
        {
            this.fellowPassengers = newValue;
        },
        createTrackingIframe()
        {
            let iframe = document.createElement('iframe');
            iframe.setAttribute('id', 'trackingIframe');
            iframe.setAttribute('src', Config.TRACKING_URL);
            iframe.style.display = "none";
            document.body.appendChild(iframe);
            let me = this;
            iframe.onload = () => me.removeTrackingIframe();
        },
        removeTrackingIframe()
        {
            let iframe = document.getElementById('trackingIframe');
            document.body.removeChild(iframe);
        },
        async checkHealth()
        {
            try
            {
                let response = await Maintenance.checkHealth();

                if (response.is_down)
                    this.showAppDown = true;
            }
            catch (error)
            {
                this.showAppDown = true;
            }
        }
    },
    async mounted()
    {
        await this.checkHealth();
        this.isInitializationDone = true;
    }
};
</script>

<style scoped>
.redColoredText{
    color: red;
}
</style>